<template>
  <div>
    <HeaderContent title="Check Out"/>
    <ActionContent ctaText="Add Check Out" @action="modal = !modal" :filterDate="false" @showFilter="modalFilter = !modalFilter"/>
    <CheckOutStatistics title="Check Out Statistics" :data="statistics" />
    <CheckOutForm :modal="modal" @update:modal="modal = $event" />
    <CheckOutFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event" />
    <CheckOutConfirm title="Check Out Confirmation" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
      <template #text>Are you sure to checkout this guest ?</template>
    </CheckOutConfirm>
    <CheckOutDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
  </div>
</template>

<script>
import { ref } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckOutForm from "./CheckOutForm.vue";
import CheckOutFilter from "./CheckOutFilter.vue";
import CheckOutConfirm from "@/components/ModalDialog.vue";
import CheckOutStatistics from "@/components/StatisticData.vue";
import CheckOutDataTable from "@/components/DataTable.vue";
import iconWill from '../../../public/icons/visit.svg';
import iconPremature from '../../../public/icons/master-plan.svg';
import iconLate from '../../../public/icons/overview.svg';
import iconCheckOut from '../../../public/icons/door-open.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    CheckOutForm,
    CheckOutFilter,
    CheckOutConfirm,
    CheckOutStatistics,
    CheckOutDataTable,

  },
  setup(){
    const data = ref([
      {
        no_room: 'A3',
        type_room: 'Deluxe',
        guest_name: 'Bones',
        checkin: '13/02/2025 12:00',
        checkout: '14/02/2025',
        day_left: '2',
        checkout_on: '14/02/2025',
        deposit: '100000',
        penalty: '0',
        bill: 1000000,
        balance: 0,
        total: 1000000,
      },
      {
        no_room: 'A1',
        type_room: 'Super Deluxe',
        guest_name: 'John',
        checkin: '13/02/2025 11:00',
        checkout: '14/02/2025',
        day_left: '2',
        checkout_on: '14/02/2025',
        deposit: '100000',
        penalty: '0',
        bill: 1000000,
        balance: 0,
        total: 1000000,
      },
      {
        no_room: 'A1',
        type_room: 'Studio',
        guest_name: 'John',
        checkin: '13/02/2025 11:00',
        checkout: '14/02/2025',
        day_left: '2',
        checkout_on: '14/02/2025',
        deposit: '100000',
        penalty: '0',
        bill: 1000000,
        balance: 0,
        total: 1000000,
      },
      {
        no_room: 'A1',
        type_room: 'Honeymoon',
        guest_name: 'John',
        checkin: '13/02/2025 11:00',
        checkout: '14/02/2025',
        day_left: '2',
        checkout_on: '14/02/2025',
        deposit: '100000',
        penalty: '0',
        bill: 1000000,
        balance: 0,
        total: 1000000,
      },
      {
        no_room: 'A1',
        type_room: 'Family',
        guest_name: 'John',
        checkin: '13/02/2025 11:00',
        checkout: '14/02/2025',
        day_left: '2',
        checkout_on: '14/02/2025',
        deposit: '100000',
        penalty: '0',
        bill: 1000000,
        balance: 0,
        total: 1000000,
      },

    ])
    const headers = ref([
      {
        key: 'no_room', label: 'Room Number', sortable: true,
      },
      {
        key: 'type_room', label: 'Room Type', sortable: true,
      },
      {
        key: 'guest_name', label: 'Guest Name', sortable: true,
      },
      {
        key: 'checkin', label: 'Checkin', sortable: true,
      },
      {
        key: 'day_left', label: 'Day Left', sortable: true,
      },
      {
        key: 'checkout', label: 'Checkout', sortable: true,
      },
      {
        key: 'deposit', label: 'Deposit', sortable: true,
      },
      {
        key: 'penalty', label: 'Penalty', sortable: true,
      },
      {
        key: 'bill', label: 'Bill', sortable: true,
      },
      {
        key: 'action', label: 'Action',
      }
    ])
    const customActions = ref([
      {
          label: 'Info',
          variant: 'success',
          icon: 'fas fa-file-alt',
          action: (item) => {
          console.log('Info action clicked for:', item);
          // Implement your Info logic here
          }
      },
      {
          label: 'Payment',
          variant: 'primary',
          icon: 'fas fa-money-bill-wave-alt',
          action: (item) => {
          console.log('Payment action clicked for:', item);
          // Implement your Payment logic here
          }
      },
      {
          label: 'Checkout',
          variant: 'danger',
          icon: 'fas fa-calendar-times',
          action: (item) => {
            modalConfirm.value = true
          console.log('Checkout action clicked for:', item);
          // Implement your Checkout logic here
          }
      },
    ])

    const modal = ref(false)
    const modalFilter = ref(false)
    const modalConfirm = ref(false)
   
    const statistics = ref([
      {
        label: 'Total',
        key: 'Will Check-Out',
        value: 3,
        color: 'warning',
        icon: iconWill,
      },
      {
        label: 'Total',
        key: 'Premature Check-Out',
        value: 8,
        color: 'warning',
        icon: iconPremature,
      },
      {
        label: 'Total',
        key: 'Late Check-Out',
        value: 8,
        color: 'danger',
        icon: iconLate,
      },
      {
        label: 'Total',
        key: 'Check-Out',
        value: 8,
        color: 'warning',
        icon: iconCheckOut,
      },
    ])  

    return{
      data,
      headers,
      modal,
      modalConfirm,
      modalFilter,
      customActions,
      statistics
    }
  }

}
</script>

<style>

</style>